export default function inputSelectConcatService() {
  return function generate(viewField, engineApi) {
    return engineApi.field.generateSelect(viewField, engineApi, 'ec-input-select-concat');
  };
}
